import React, { useMemo, useRef } from 'react';
import EChartCommon from '@/pages/opinion/components/EChartCommon';
import { mathFormat } from '@/pages/opinion/utils';
import { formatChartParamsDate } from '@/pages/opinion/components/ChartCommon/formatter';
import { reviewsFormat } from '@/pages/opinion/utils/value';
import { useIntl, getLocale } from 'umi';
import { baseColors, extendColors } from '@/pages/opinion/constants';
import { dealWithOthersName } from '@op/utils/languageValue';
interface chartInterFace {
  title?: string;
  chartData: any;
  total: number;
  formatText?: (text: string) => string;
}

export default function PieEchart({
  chartData,
  title = '',
  total,
  formatText = (text: string) => text,
}: chartInterFace) {
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const eChartsRef = useRef(null);

  const colorArr = [...baseColors, ...extendColors];

  // 设置图形配置
  const makeupOptions = () => {
    let newLegendData: Array<any> = [];
    let newCharData: Array<any> = [];

    newCharData = chartData.map((v: { name: any }, i: number) => {
      const color = colorArr[i];
      newLegendData.push({
        name: formatText(v.name),
        icon: 'circle',
        itemStyle: {
          color: color,
        },
      });

      return {
        ...v,
        name: formatText(v.name),
        itemStyle: {
          color: color,
        },
      };
    });

    const opts = {
      color: colorArr,
      legend: {
        data: newLegendData,
      },
      tooltip: {
        formatter: (params: any) => {
          return formatChartParamsDate({
            title: params.name,
            params: params,
            valueFormat: (value, element) => {
              return `${reviewsFormat(value)}(${element.percent}%)`;
            },
            listTitleFunc: () => formatMessage({ id: 'News Mentions' }),
          });
        },
      },
      title: [
        {
          text: '{name|' + mathFormat(total) + '}',
          top: '43%',
          left: 'center',
          textStyle: {
            rich: {
              name: {
                fontSize: 16,
                fontFamily: 'num-m',
                fontWeight: 'bold',
                color: '#000000',
                padding: [10, 0],
              },
              val: {
                fontSize: 32,
                fontWeight: 'bold',
                color: '#333333',
              },
            },
          },
        },
      ],
      graphic: [
        {
          type: 'text',
          left: 'center',
          top: '34%',
          style: {
            fill: '#444444',
            fontSize: 12,
            text: title || '',
          },
        },
      ],
      series: [
        // {
        //   labelLayout: (params: {
        //     labelRect: { x: number; width: any };
        //     labelLinePoints: any;
        //   }) => {
        //     const points = params.labelLinePoints;
        //     // Update the end point.
        //     points[2][0] = params.labelRect.x;
        //     return {
        //       labelLinePoints: points,
        //     };
        //   },
        //   data: newCharData,
        // },
        {
          labelLayout: (params: any) => {
            const isLeft =
              params.labelRect.x <
              eChartsRef?.current?.getEchartsInstance?.()?.getWidth() / 2;
            const points = params.labelLinePoints;
            // Update the end point.
            points[2][0] = isLeft
              ? params.labelRect.x
              : params.labelRect.x + params.labelRect.width;
            return {
              labelLinePoints: points,
            };
          },
          label: {
            color: '#262832',
            alignTo: 'edge',
            formatter: (params: any) => `{value| ${dealWithOthersName(params.name, 'language')}}: {a|${mathFormat(params.value)}${params?.value ? `(${params.percent}%)` : ''}}\n{hr|}\n{a|}`,
            edgeDistance: 10,
            rich: {
              a: {
                // color: '#999',
                lineHeight: 20, // 设置最后一行空数据高度，为了能让延长线与hr线对接起来
                align: 'center',
              },
              hr: {
                // 设置hr是为了让中间线能够自适应长度
                borderColor: 'auto', // hr的颜色为auto时候会主动显示颜色的
                width: '105%',
                borderWidth: 0.5,
                height: 0.5,
              },
              per: {
                // 用百分比数据来调整下数字位置，显的好看些。如果不设置，formatter最后一行的空数据就不需要
                padding: [4, 0],
              },
            },
          },
          data: newCharData,
        }
      ],
    };
    return opts;
  };

  const options = useMemo(() => {
    if (!chartData) {
      return {};
    }
    return makeupOptions();
  }, [chartData, locale]);

  return (
    <EChartCommon
      optionsProps={{ type: 'pie' }}
      options={options}
      empty={chartData.length === 0}
      height={300}
      ref={eChartsRef}
    ></EChartCommon>
  );
}

